<form [formGroup]="listaAcuseSuperForm" (ngSubmit)="onSubmit()" #superFormRef="ngForm">
	<div class="modal-body">
		<div class="mb-4 p-3 border rounded bg-light">
			<div class="d-flex justify-content-between align-items-center mb-3">
				<label class="mb-0 font-weight-bold"> Usar comentario global para todos los documentos </label>
				<label class="toggle-switch">
					<input type="checkbox" [(ngModel)]="useGlobalComment" [ngModelOptions]="{ standalone: true }" (change)="onGlobalCommentToggle()" />
					<span class="toggle-slider"></span>
				</label>
			</div>
			<div *ngIf="useGlobalComment" class="animate-fade-in">
				<div class="form-group row mx-auto">
					<label class="col-12 col-md-3 label-control font-weight-bold mb-5">Comentario Global</label>
					<div class="col-12 col-md-9">
						<textarea class="form-control" rows="3" [(ngModel)]="globalComment" maxlength="200" [ngModelOptions]="{ standalone: true }" placeholder="Ingrese un comentario que se aplicará a todos los documentos" [class.is-invalid]="superFormRef.submitted && !globalComment"></textarea>
						<div class="d-flex justify-content-between">
							<small class="form-text"> <i class="fa fa-info-circle"></i> Este comentario se aplicará a todos los documentos seleccionados </small>
							<small class="form-text">{{ globalComment.length }} / 200 caracteres</small>
						</div>

						<div *ngIf="superFormRef.submitted && !globalComment" class="invalid-feedback d-block">El comentario global es requerido</div>
					</div>
				</div>
			</div>
		</div>
		<div formArrayName="lista">
			<ng-container *ngFor="let docAcuse of getListFormArray().controls; let i = index">
				<h4>{{ itemsReception[i].nombreTipoDte }} N° {{ itemsReception[i].folio }} de {{ itemsReception[i].razonSocialProveedor }}</h4>
				<div [formGroupName]="i" class="mb-5">
					<div class="form-group row mx-auto">
						<label class="col-3 label-control" for="projectinput1">Motivo</label>
						<div class="col-9">
							<ng-select [items]="motivos" [searchable]="false" [clearable]="false" [selectOnTab]="false" formControlName="response" bindLabel="name">
								<ng-template ng-option-tmp let-item="item">
									{{ item.name }}
								</ng-template>
							</ng-select>
							<div *ngIf="(superFormRef.submitted || getGroupFormAcuseArray(i).get('response').touched || getGroupFormAcuseArray(i).get('response').dirty) && getGroupFormAcuseArray(i).get('response').invalid" class="invalid-feedback">
								<div *ngIf="getGroupFormAcuseArray(i).get('response').errors?.required">Campo requerido</div>
							</div>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="rechazoRelatedValue(docAcuse.controls.response.value)">
						<label class="col-3 label-control" for="projectinput1">Motivo de Rechazo</label>
						<div class="col-9">
							<ng-select [items]="AcuseReciboRejectedTypes" [searchable]="false" [clearable]="false" [selectOnTab]="false" formControlName="rejectionType" bindLabel="nombre"> </ng-select>
							<div *ngIf="(superFormRef.submitted || getGroupFormAcuseArray(i).get('rejectionType').touched || getGroupFormAcuseArray(i).get('rejectionType').dirty) && getGroupFormAcuseArray(i).get('rejectionType').invalid" class="invalid-feedback">
								<div *ngIf="getGroupFormAcuseArray(i).get('rejectionType').errors?.required">Campo requerido</div>
							</div>
						</div>
					</div>
					<div class="form-group row mx-auto" *ngIf="!useGlobalComment">
						<div class="col-3 label-control">Comentario</div>
						<div class="col-9">
							<input type="text" class="form-control" formControlName="description" placeholder="Ingrese comentario" />
							<div *ngIf="(superFormRef.submitted || getGroupFormAcuseArray(i).get('description').touched || getGroupFormAcuseArray(i).get('description').dirty) && getGroupFormAcuseArray(i).get('description').invalid" class="invalid-feedback">
								<div *ngIf="getGroupFormAcuseArray(i).get('description').errors?.required">Campo requerido</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
	<div class="modal-footer">
		<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
			<i class="la la-paper-plane-o d-lg-none"></i>
			<span class="d-none d-lg-block">Guardar</span>
		</button>
		<button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
			<span class="d-none d-lg-block">Cerrar</span>
		</button>
	</div>
</form>
